/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOnboardingThirdPartyBody
 */
export interface CreateOnboardingThirdPartyBody {
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingThirdPartyBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingThirdPartyBody
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateOnboardingThirdPartyBody interface.
 */
export function instanceOfCreateOnboardingThirdPartyBody(value: object): value is CreateOnboardingThirdPartyBody {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function CreateOnboardingThirdPartyBodyFromJSON(json: any): CreateOnboardingThirdPartyBody {
    return CreateOnboardingThirdPartyBodyFromJSONTyped(json, false);
}

export function CreateOnboardingThirdPartyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOnboardingThirdPartyBody {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateOnboardingThirdPartyBodyToJSON(json: any): CreateOnboardingThirdPartyBody {
    return CreateOnboardingThirdPartyBodyToJSONTyped(json, false);
}

export function CreateOnboardingThirdPartyBodyToJSONTyped(value?: CreateOnboardingThirdPartyBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
    };
}

